var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0387 0.459961C4.73681 0.459961 0.42334 4.77321 0.42334 10.0753C0.42334 15.3775 4.73659 19.6907 10.0387 19.6907C15.3409 19.6907 19.6541 15.3775 19.6541 10.0753C19.6541 4.77321 15.3409 0.459961 10.0387 0.459961ZM10.0387 17.7683C5.79723 17.7683 2.34556 14.3168 2.34556 10.0751C2.34556 5.83279 5.79702 2.38197 10.0387 2.38197C14.2804 2.38197 17.7319 5.83343 17.7319 10.0751C17.7319 14.3168 14.2804 17.7683 10.0387 17.7683Z",
    fill: "black",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 3.85449H9.07764V10.6023L9.75842 11.0362L14.6208 14.1365L15.6536 12.5155L10.9999 9.54777L10.9999 3.85449Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
export default __webpack_public_path__ + "static/media/clock.83674cb0.svg";
export { SvgComponent as ReactComponent };